import { trendsApi } from "../components/TrendsDashboard/state/api";

const apis = [trendsApi];

export const apiReducers = apis.reduce((acc, api) => {
    acc[api.reducerPath] = api.reducer;
    return acc;
}, {});

export const apiMiddlewares = apis.map((api) => api.middleware);
